import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetPostCheckoutQuestions {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * GetPostCheckoutQuestions constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
        this.apiService.enableAuth();
    }

    /**
     * Get list of post checkout questions.
     *
     * @returns {Array}
     */
    async handle() {
        let request = await this.apiService
            .get(ApiEndpoints['users.postcheckout-questions.index'])
            .catch(() => false);

        return request ? request.data.data : [];
    }
}
